import Banner from "./Banner";
import BigNameCustomer from "./BigNameCustomer";
import Expertise from "./Expertise";
import VisionAndValue from "./VisionAndValue";

const AboutUs = () => {
  return (
    <>
      <Banner />
      <BigNameCustomer />
      <VisionAndValue />
      <Expertise />
    </>
  );
};

export default AboutUs;
